import { DEFAULT_PAGE_SIZE } from '@w7/ui'
import { ApiError, hasLiveApi } from '@/api/client'
import {
  playersWithBlockedDevices,
  toBlockedDeviceResult,
} from '@/api/map/blockedDevices'
import type { BlockedDeviceQuery, BlockedDeviceResult } from './blockedDeviceTypes'

/** Empty page when demo / offline — no invented blocked-device rows. */
export function emptyBlockedDevices(
  query: BlockedDeviceQuery = {},
): BlockedDeviceResult {
  const pageSize = Math.max(1, query.pageSize ?? DEFAULT_PAGE_SIZE)
  const page = Math.max(1, query.page ?? 1)
  return {
    rows: [],
    total: 0,
    page,
    pageSize,
  }
}

/**
 * Live Keycloak → hierarchy `playersWithBlockedDevices`.
 * Demo / no live API → empty (never invent blocked-device rows).
 */
export async function loadBlockedDevices(
  query: BlockedDeviceQuery = {},
): Promise<BlockedDeviceResult> {
  if (!hasLiveApi()) return emptyBlockedDevices(query)

  try {
    const live = await playersWithBlockedDevices({
      page: query.page ?? 1,
      pageSize: query.pageSize ?? DEFAULT_PAGE_SIZE,
      deviceId: query.deviceId,
      player: query.player,
    })
    if (!live.value) return emptyBlockedDevices(query)
    return toBlockedDeviceResult(live, query)
  } catch (err) {
    const status = err instanceof ApiError ? err.status : 0
    console.warn(
      '[blocked-devices] hierarchy playersWithBlockedDevices unavailable',
      err,
    )
    if (status === 404) {
      console.warn(
        '[blocked-devices] Agent-API blockedDevices route is not deployed on this hierarchy yet.',
      )
    }
    return emptyBlockedDevices(query)
  }
}
